import EventEmitter from './EventEmitter';
import DomU, {$} from './DomU';
import _ from '../vendors/_';
import AbstractModule from '../modules/AbstractModule';

interface ModuleList {
  [name:string]: any;
}

export default new class ModuleCtrl extends EventEmitter {
  private _instances: AbstractModule[];
  private _unstartedInstances: AbstractModule[] = [];
  private _modules: ModuleList;

  setup(modules) {
    this._modules = modules;
  }

  init($area: DomU = null, $scroller: DomU = null) {
    if (!this._modules) throw '[ModuleCtrl] needs calling setup()';
    if (!$area) $area = $('body');
    if (!$scroller) $scroller = $(window);
    this._instances = _.flatten(_.map(this._modules, (item:{klass: any, name: string}) => {
      const {klass, name} = item;
      return $area.find$(`.${name}`).map(($el, index) => {
        const instance = new klass($el, {index, $scroller});
        $el.data('module-instance', instance);
        return instance;
      });
    }));
    this._unstartedInstances = this._unstartedInstances.concat(this._instances);
    return Promise.all(this._instances.map((instance) => {
      return instance.init();
    }));
  }

  start() {
    this._unstartedInstances.forEach((instance) => {
      instance.start();
    });
    this._unstartedInstances = [];
    return Promise.resolve();
  }

}();
